import { useState } from "react";
import { useNavigate } from "react-router-dom";
import Customer from ".";
import ConfirmDialog from "src/Common/confirmdialog";
import DropDown from "src/Components/EditDeleteDropdown/dropdown";
import { isClericalOver, isAccountant } from "src/Common/function";
import { setCustomerName } from "src/Redux/Slices/HeaderSlice";
import { useDispatch } from "react-redux";

function CustomerTable({ customers, onArchiveCustomer, onEditClicked }) {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [isArchiveConfirmDialogShown, setIsArchiveConfirmDialogShown] = useState(false);
  const [indexForArchive, setIndexForArchive] = useState(0);

  const archiveClicked = (index) => {
    setIsArchiveConfirmDialogShown(true);
    setIndexForArchive(index);
  };

  const editClicked = (index) => {
    onEditClicked(index);
  };

  return (
    <div>
      {isArchiveConfirmDialogShown && (
        <ConfirmDialog
          title="ARCHIVE CUSTOMER"
          description="Are you sure you want to archive this?"
          shown={isArchiveConfirmDialogShown}
          onConfirmClicked={() => {
            onArchiveCustomer(indexForArchive);
            setIsArchiveConfirmDialogShown(false);
          }}
          onCancelClicked={() => setIsArchiveConfirmDialogShown(false)}
        />
      )}

      <table className="w-full border-t-[1px] border-borderColor">
        <thead>
          <tr className=" border-b-[1px] border-borderColor">
            <th className="border-r-[1px] border-borderColor">
              <div className="font-OpenSansRegular font-[700] text-[12px] flex items-center px-4 h-[40px] text-titleColor">
                <span>No.</span>
              </div>
            </th>
            <th className="border-r-[1px] border-borderColor">
              <div className="font-OpenSansRegular font-[700] text-[12px] flex items-center px-4 h-[40px] text-titleColor">
                <span>Company</span>
              </div>
            </th>
            <th className="border-r-[1px] border-borderColor w-[160px]">
              <div className="font-OpenSansRegular font-[700] text-[12px] flex items-center pl-4 h-[40px] text-titleColor">
                Contact Name
              </div>
            </th>
            <th className="border-r-[1px] border-borderColor w-[230px]">
              <div className="font-OpenSansRegular font-[700] text-[12px] flex items-center pl-4 h-[40px] text-titleColor">
                Email Address
              </div>
            </th>
            <th className="border-r-[1px] border-borderColor w-[130px]">
              <div className="font-OpenSansRegular font-[700] text-[12px] flex items-center pl-4 h-[40px] text-titleColor">
                Phone
              </div>
            </th>
            <th className="border-r-[1px] border-borderColor w-[370px]">
              <div className="font-OpenSansRegular font-[700] text-[12px] flex items-center pl-4 h-[40px] text-titleColor">
                Address
              </div>
            </th>
            <th className="border-r-[1px] border-borderColor w-[130px]">
              <div className="font-OpenSansRegular font-[700] text-[12px] flex items-center pl-4 h-[40px] text-titleColor">
                Branch
              </div>
            </th>
            <th className="w-[130px]">
              <div className="font-OpenSansRegular  font-[700] text-[12px] flex items-center pl-4 h-[40px] text-titleColor">
                Date Added
              </div>
            </th>
            <th className="w-[30px] border-r-[1px] border-borderColor "></th>
          </tr>
        </thead>
        <tbody>
          {customers.map((customer, i) => (
            <tr
              onClick={() => {
                dispatch(setCustomerName(customer.companyName));
                navigate(`/customer/${customer.id}`);
              }}
              key={i}
              className="border-b-[1px] border-borderColor h-[40px] cursor-pointer"
            >
              <td className="border-r-[1px]  border-borderColor">
                <div className="font-OpenSansRegular px-[15px] py-[5px] text-[12px] font-[400] col-span-1 word-break-break-word">
                  {i + 1}
                </div>
              </td>
              <td className="border-r-[1px]  border-borderColor">
                <div className="font-OpenSansRegular px-[15px] py-[5px] text-[12px] font-[400] col-span-1 word-break-break-word">
                  {customer.companyName}
                </div>
              </td>
              <td className="border-r-[1px]  border-borderColor">
                <div className="font-OpenSansRegular px-[15px] py-[5px] text-[12px] font-[400] col-span-1 word-break-break-word">
                  {customer.contact}
                </div>
              </td>
              <td className="border-r-[1px]  border-borderColor">
                <div className="font-OpenSansRegular px-[15px] py-[5px] text-[12px] font-[400] col-span-1 word-break-break-word">
                  {customer.email}
                </div>
              </td>
              <td className="border-r-[1px]  border-borderColor">
                <div className="font-OpenSansRegular px-[15px] py-[5px] text-[12px] font-[400] col-span-1 word-break-break-word">
                  {customer.phone}
                </div>
              </td>
              <td className="border-r-[1px]  border-borderColor">
                <div className="font-OpenSansRegular px-[15px] py-[5px] text-[12px] font-[400] col-span-1 word-break-break-word">
                  {customer.address}
                </div>
              </td>
              <td className="border-r-[1px]  border-borderColor">
                <div className="font-OpenSansRegular px-[15px] py-[5px] text-[12px] font-[400] col-span-1 word-break-break-word">
                  {customer.branch ? customer.branch.name : ""}
                </div>
              </td>
              <td>
                <div className="font-OpenSansRegular px-[15px] py-[5px] text-[12px] font-[400] col-span-1">
                  {customer.formattedCreatedAt}
                </div>
              </td>
              {(isClericalOver() || isAccountant()) && (
                <td
                  onClick={(e) => {
                    e.stopPropagation(); // Prevent click event from propagating to <tr>
                  }}
                >
                  <DropDown index={i} onDeleteClicked={archiveClicked} onEditClicked={editClicked} />
                </td>
              )}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

export default CustomerTable;
